export default __webpack_public_path__ + "static/media/wTop_1.efb6f9f8.bin";